import {
  examFilterOptionListAtom,
  filterOptionType,
  levelFilterOptionListAtom,
  subjectFilterOptionListAtom,
} from '@atom/examResultAtom';
import { useStudentExamResultFilterOptions } from '@hooks/student.hook';
import {
  ExamFilter,
  LevelFilter,
  SubjectFilter,
} from '@models/interfaces/student.interface';
import { useAtom } from 'jotai';
import { useEffect } from 'react';

// function to transform data and add "All" option
const transformFilterOption = <
  T extends { [key in K | V]: string },
  K extends keyof T,
  V extends keyof T,
>(
  data: T[],
  labelKey: K,
  valueKey: V,
): filterOptionType[] => {
  return [
    { label: 'All', value: 'All' },
    ...data.map(item => ({
      label: item[labelKey],
      value: item[valueKey],
    })),
  ];
};

const FilterPreprocessor = () => {
  const examFilterOptions = useStudentExamResultFilterOptions('exam'); // "Type" filter
  const subjectFilterOptions = useStudentExamResultFilterOptions('subject');
  const levelFilterOptions = useStudentExamResultFilterOptions('level');

  const [, setExamFilterOptionList] = useAtom(examFilterOptionListAtom);
  const [, setSubjectFilterOptionList] = useAtom(subjectFilterOptionListAtom);
  const [, setLevelFilterOptionList] = useAtom(levelFilterOptionListAtom);

  useEffect(() => {
    const data = examFilterOptions.data?.data.data as ExamFilter[] | undefined;

    if (data && data.length > 0) {
      const transformedData = transformFilterOption(
        data,
        'exam_name',
        'exam_type_id',
      );
      setExamFilterOptionList(transformedData);
    }
  }, [examFilterOptions.data?.data.data]);

  useEffect(() => {
    const data = subjectFilterOptions.data?.data.data as
      | SubjectFilter[]
      | undefined;

    if (data && data.length > 0) {
      const transformedData = transformFilterOption(
        data,
        'subject',
        'subject_id',
      );
      setSubjectFilterOptionList(transformedData);
    }
  }, [subjectFilterOptions.data?.data.data]);

  useEffect(() => {
    const data = levelFilterOptions.data?.data.data as
      | LevelFilter[]
      | undefined;

    if (data && data.length > 0) {
      const transformedData = transformFilterOption(data, 'level', 'level_id');
      setLevelFilterOptionList(transformedData);
    }
  }, [levelFilterOptions.data?.data.data]);

  return null;
};

export default FilterPreprocessor;
